/**
 * @generated SignedSource<<a560ea44b2ab03f435923f2706ff854c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionCardCarouselContentfulRelayFragment$data = ReadonlyArray<{
  readonly sys: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"collectionCardContentfulRelayFragment">;
  readonly " $fragmentType": "collectionCardCarouselContentfulRelayFragment";
}>;
export type collectionCardCarouselContentfulRelayFragment$key = ReadonlyArray<{
  readonly " $data"?: collectionCardCarouselContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionCardCarouselContentfulRelayFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "collectionCardCarouselContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sys",
      "kind": "LinkedField",
      "name": "sys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "collectionCardContentfulRelayFragment"
    }
  ],
  "type": "TemplateCollection",
  "abstractKey": null
};

(node as any).hash = "fdf5e06b0b871f667490c5a097846cff";

export default node;
